const FakeOrders = [
    {
      order_id: 1,
      user_id: "",
      payment_id: "",
      quantity:2,
      status: "Shipped",
      created_at: "02.01.2015 19:47",
      modified_at: "02.02.2015 19:47",
    },
    {
      order_id: 2,
      user_id: "",
      payment_id: "",
      quantity:5,
      status:"Backorder",
      created_at: "02.01.2015 19:47",
      modified_at: "02.02.2015 19:47",
    },
  ];
  
  export default FakeOrders;
  